import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@didto/ui/tokens.css';
import '@didto/ui/base.css';
import { AppRouter } from './app/router';
import { SessionProvider } from './app/session';
import { ToastProvider } from './app/toast';
import { UpdatePrompt } from './app/pwa';
import { startTheme } from './app/theme';
import { assertEnv } from './lib/env';
import { report } from './lib/reporter';

assertEnv();
startTheme();
// Phase 0 section J.2: ask Chrome not to evict this origin's storage under pressure (outbox, caches).
if (typeof navigator !== 'undefined' && navigator.storage?.persist) {
  void navigator.storage.persist().catch(() => undefined);
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 15_000 } },
});

window.addEventListener('unhandledrejection', (e) =>
  report().captureException(e.reason, { source: 'unhandledrejection' }),
);
window.addEventListener('error', (e) =>
  report().captureException(e.error ?? e.message, { source: 'window.error' }),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <SessionProvider>
          <AppRouter />
          <UpdatePrompt />
        </SessionProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
